import React from 'react';
import { Box, SxProps } from '@mui/material';

interface ChatsTableLayoutProps {
  sx?: SxProps;
  table: React.ReactNode;
}

const ChatsTableLayout = ({ sx, table }: ChatsTableLayoutProps) => {
  return (
    <Box
      sx={[
        {
          maxWidth: '100%',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {table}
    </Box>
  );
};

export default ChatsTableLayout;
